<template>
  <v-container class="page">
    <h3 style="text-align: center; margin-top: 20px; margin-bottom: 15px;">
      ANEKS DO UMOWY TURYSTYCZNEJ NR {{ nrUmowy }} Z DNIA
      {{
        new Date()
          .toJSON()
          .slice(0, 10)
          .replace(/(\d+)-(\d+)-(\d+)/, "$3-$2-$1")
      }}
    </h3>
    <table id="table_container">
      <tbody>
        <tr>
          <td style="border: 1px solid;">
            <p class="cell-in-first-table">
              <span><strong>Organizator</strong></span>
            </p>
            <p class="cell-in-first-table" style="fontStyle: italic;">
              <span>Tutore Poland Sp. z o.o.</span>
            </p>
            <p class="cell-in-first-table">
              <span>ul. Piotrkowska 157A, 90-440 Łódź</span>
            </p>
            <p class="cell-in-first-table">
              <span>NIP 727 281 2193</span>
            </p>
            <p class="cell-in-first-table">
              <span>KRS 0000670834</span>
            </p>
            <p class="cell-in-first-table">
              <span
                >Kapitał Zakładowy: 2 000 000,00 zł, w całości opłacony</span
              >
            </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <p
              class="cell-in-first-table"
              style="margin-top: 5px; margin-bottom: 5px;"
            >
              <strong> Miejsce i czas trwania:</strong> {{ turnus.slice(3) }}
            </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <p
              class="cell-in-first-table"
              style="margin-top: 5px; margin-bottom: 5px;"
            >
              <strong> Nazwa obozu lub imprezy:</strong> {{ oboz.slice(3) }}
            </p>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Dane zgłaszającego:</strong>
              <p style="margin-top: 7px;">
                Imię i nazwisko: {{ imieNazwiskoOpiekuna
                }}<span style="margin-left: 200px;">tel: {{ tel }}</span>
              </p>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Dane uczestnika/uczestników:</strong
              ><span style="font-size: 11px;">
                (imię i nazwisko, data urodzenia, adres zamieszkania):</span
              >
              <p style="margin-top: 5px;">
                1. {{ imieDziecka }} {{ nazwiskoDziecka }},
                {{ dataUrodzeniaDziecka }}, {{ adres }}
              </p>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Zakupione świadczenia:</strong>
              <ol>
                <li>
                  Obóz: {{ oboz.slice(3) }}: {{ turnus.slice(3) }} (
                  {{ showCenaObozu() }}
                  zł)
                </li>
                <li>Dojazd: {{ dojazd }}</li>
                <li>Powrót: {{ powrot }}</li>
                <li>Opcje dodatkowe:</li>
                <ul>
                  <li v-if="pendrive !== 'Nie (0 zł)'">
                    Pendrive: {{ pendrive }}
                  </li>
                  <li v-if="dieta !== 'Brak (0 zł)'">{{ dieta }}</li>
                  <li v-if="pakietSafety !== 'Brak (0 zł)'">
                    Pakiet Safety: {{ pakietSafety }}
                  </li>
                  <li v-if="wypozyczenieSprzetu">
                    Wypożyczenie sprzętu: {{ wypozyczenieSprzetu }}
                  </li>
                </ul>
                <li>
                  Rabaty i znizki: {{ rabatUzasadnienie }} (-{{ rabat }} zł)
                </li>
              </ol>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Płatności:</strong>
              <p>Cena całkowita: {{ cenaCalkowita }} zł</p>
              <p>
                Zaliczka płatna do {{ terminZaliczka }}:
                {{ countZaliczka() }} zł
              </p>
              <p>
                Pozostała część kwoty płatna do {{ terminResztaKwota }}:
                {{ cenaCalkowita - countZaliczka() }} zł
              </p>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <p class="cell-in-first-table">
              <span><strong>Dane do przelewu (Organizatora)</strong></span>
            </p>
            <p class="cell-in-first-table" style="fontStyle: italic;">
              <span>Tutore Poland Sp. z o.o.</span>
            </p>
            <p class="cell-in-first-table">
              <span>ul. Piotrkowska 157A, 90-440 Łódź</span>
            </p>
            <p class="cell-in-first-table">
              <span>76 1090 2590 0000 0001 3433 5287</span>
            </p>
          </td>
        </tr>

        <tr v-if="zgodaWizerunek === 'Tak'">
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <strong>Zgoda na wykorzystywanie wizerunku</strong>
              <p>
                Wyrażam zgodę na utrwalanie oraz nieodpłatne, wielokrotne,
                rozpowszechnianie wizerunku uczestnika obozu zimowego na: panelu
                będącym częścią strony Organizatora, w którym prezentowane będą
                relacje fotograficzne i filmowe z obozów; nośnikach trwałych
                typu płyta CD lub pendrive, które zawierały będą relacje z
                obozów; stronie www Organizatora, na stronach w social media
                Organizatora (np. Facebook, Instagram, Twitter), w materiałach
                reklamowych (katalogi, ulotki). W każdym momencie zgoda może być
                cofnięta, poprzez wysłanie informacji na adres
                obozy@musicandmore.pl.
              </p>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table">
              <p>
                Ja niżej podpisany/a zapoznałem się z ceną, programem, zakresem
                usług oraz Warunkami Uczestnictwa, zgłaszam udział w imprezie
                wyżej wymienionych osób i zobowiązuję się do uregulowania
                należności w terminach opisanych w Warunkach Uczestnictwa.
              </p>
              <div class="flex-container" style="margin-bottom: 25px;">
                <div class="aside flex-item">
                  ------------------------------------
                </div>
                <div class="aside flex-item">
                  -----------------------------------------
                </div>
                <div class="flex-item">Miejscowość i data</div>
                <div class="flex-item">Podpis klienta</div>
              </div>
            </div>
          </td>
        </tr>

        <tr>
          <td style="border: 1px solid;">
            <div class="cell-in-first-table" style="font-size: 10px;">
              <p style="font-size: 10px; margin-bottom: 0px;">
                <br />
                <strong>RODO</strong>
              </p>
              <p style="margin-bottom: 0px;">
                Wyrażam zgodę na przetwarzanie danych dotyczących stanu zdrowia
                mojego dziecka/podopiecznego przez Tutore Poland Sp. z o.o. w
                celu jego/jej uczestnictwa w koloniach. Oświadczam, że
                zapoznałem się z poniższą klauzulą informacyjną:
              </p>
              <p style="margin-bottom: 0px;">
                Zgodnie z art. 13 ust. 1 i 2 RODO* informuję, że: 1.
                Administratorem Państwa danych osobowych jest Tutore Poland Sp. z o.o. z siedzibą w Łodzi przy ul. Piotrkowska 157A,
                90-440 Łódź. 2. Państwa dane osobowe będą przetwarzane w celu
                uczestnictwa Państwa dziecka/podopiecznego w koloniach na
                podstawie art. 6 ust. 1 lit. b i c, art. 9 ust. 2 lit. a oraz na
                podstawie art. 6 ust. 1 lit. e RODO. 3. W niektórych sytuacjach
                mamy prawo przekazywać dane Państwa oraz Państwa
                dziecka/podopiecznego dalej – jeśli jest to konieczne, abyśmy
                mogli wykonywać nasze usługi. Możemy przekazywać dane Państwa
                oraz Państwa dziecka/podopiecznego w szczególności następującym
                odbiorcom: a) osobom upoważnionym przez nas b) naszym
                pracownikom i współpracownikom, którzy muszą mieć dostęp do
                danych, aby wykonywać swoje obowiązki; c) podmiotom
                przetwarzającym – którym zlecimy czynności przetwarzania danych,
                d) innym odbiorcom danych np. ubezpieczycielom. 4. Państwa dane
                po zrealizowaniu celu pierwotnego, dla którego zostały zebrane,
                o jakim była mowa wcześniej, będą przetwarzane dla celów
                archiwalnych przez okres zgodny z obowiązującymi przepisami
                prawa lub do czasu przedawnienia wzajemnych roszczeń. 5. Mają
                Państwo prawo zwrócić się z żądaniem dostępu do danych Państwa
                lub Państwa dziecka/podopiecznego, ich sprostowania, usunięcia
                lub ograniczenia przetwarzania, wniesienia sprzeciwu wobec
                przetwarzania, przenoszenia danych – zgodnie z obowiązującymi
                przepisami. Możecie Państwo wycofać też zgodę na przetwarzanie
                danych w dowolnym momencie bez wpływu na zgodność z prawem
                przetwarzania, którego dokonano na podstawie tej zgody przed jej
                cofnięciem. 6. Mają Państwo prawo wniesienia skargi do Organu
                nadzorczego (w rozumieniu RODO) dotyczącą przetwarzanie danych
                Państwa lub Państwa dziecka/podopiecznego.
              </p>
              <p>
                *RODO - Rozporządzenie Parlamentu Europejskiego i Rady (UE)
                2016/679 z dnia 27 kwietnia 2016 r. w sprawie ochrony osób
                fizycznych w związku z przetwarzaniem danych osobowych i w
                sprawie swobodnego przepływu takich danych oraz uchylenia
                dyrektywy 95/46/WE.
              </p>
              <p id="signature_space">
                --------------------------------------------------------------------------------
              </p>
              <p id="signature">Podpis Rodzica lub Opiekuna</p>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </v-container>
</template>

<script>
export default {
  name: "UmowaGitara",
  props: {},
  data() {
    return {
      turnus: "",
      oboz: "",
      imieDziecka: "",
      nazwiskoDziecka: "",
      dataUrodzeniaDziecka: "",
      nrUmowy: "",
      tel: "",
      imieNazwiskoOpiekuna: "",
      adres: "",
      cenaCalkowita: "",
      dojazd: "",
      powrot: "",
      pendrive: "",
      dieta: "",
      pakietSafety: "",
      rabat: "",
      rabatUzasadnienie: "",
      wypozyczenieSprzetu: "",
      terminZaliczka: "",
      terminResztaKwota: "",
      kwotaOboz: "",
      zgodaWizerunek: "",
    };
  },
  created() {
    Object.entries(this.$route.query).forEach(([key, value]) => {
      this[key] = value;
    });
  },
  methods: {
    showCenaObozu() {
      switch (this.oboz.slice(3)) {
        case 'Narciarski "Pierwsze kroki"':
          return 1790;
          break;
        case "Narciarski":
          return 1850;
          break;
        case "Snowboardowy":
          return 1790;
          break;
        case "Zimowe szaleństwo":
          return 1690;
          break;
        case "W świecie Minecraft":
          return 1790;
          break;
        case "Rysunek i malarstwo":
          return 1690;
          break;
        case "FIRST® LEGO® League":
          return 1790;
          break;
        default:
          return "nic";
      }
    },
    countZaliczka() {
      let pakiet = 0;
      switch (this.pakietSafety) {
        case "Brak (0 zł)":
          pakiet = 0;
          break;
        case "Safety Basic (79 zł)":
          pakiet = 79;
          break;
        case "Safety Premium (139 zł)":
          pakiet = 139;
          break;
      }
      const finalZaliczka = 600 + pakiet;
      return finalZaliczka;
    },
  },
  mounted() {
    if (this.turnus) {
      this.$nextTick(() => {
        window.setTimeout(() => {
          const currentURL = window.location.href;
          history.replaceState(history.state, "", "/");
          window.print();
          history.replaceState(history.state, "", currentURL);
        }, 300);
      });
    }
  },
};
</script>

<style scoped>
#table_container {
border: 1px solid;
text-align: left;
margin: auto;
width: 100%;
}
.page {
  size: 210mm 297mm;
  background-size: 100% 100%;
  line-height: 1.4;
  text-align: justify;
  margin-top: 0px;
  padding-top: 0px;
}
table, th, td {
  border: 1px;
  border-collapse: collapse;
}
.cointainer {
  width: 100%;
  display: flex;
  justify-content: space-between;
}
.cointainer-left {
  width: 20%;
}
.cointainer-right {
  width: 20%;
}
thead {
  display: table-header-group;
}
.table-border {
  border: 1px solid black;
  border-collapse: collapse;
  padding: 5px;
}
.cell-in-first-table {
  margin-top: 2px;
  margin-bottom: 2px;
  margin-left: 5px;
}
#signature_space {
  font-size: 14px;
  float: right;
  margin-right: 10px;
  margin-top: 27px;
}
#signature {
    font-size: 14px;
    float: right;
    margin-top: 50px;
    margin-right: -246px;
    margin-bottom: 15px;
}
.flex-container {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    flex-wrap: wrap;
}
.flex-item {
    width: 300px;
    height: 20px;
    text-align: center;
    margin: auto;
}
</style>



// WEBPACK FOOTER //
// src/components/AneksUmowaKolonie.vue